import { render, staticRenderFns } from "./FormTextArea.vue?vue&type=template&id=a691b34c&scoped=true&"
import script from "./FormTextArea.vue?vue&type=script&lang=js&"
export * from "./FormTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a691b34c",
  null
  
)

export default component.exports